import moment from 'moment'
import React, {useEffect, useMemo, useState} from 'react'
import ReactPaginate from 'react-paginate'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import FileCopyTwoTone from '@material-ui/icons/FileCopyTwoTone'
import {AutomationData} from '../../../Utils/Constant/automationData'
import DeleteConfirmationPopup from '../../../Components/DeleteConfirmationPopup'
import NodataYet from '../../../Components/NodataYet'
import {KTSVG, toAbsoluteUrl} from '../../../../_metronic/helpers'
import ReactApexChart from 'react-apexcharts'

const Reviews = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [quickResponseModel, setQuickResponseModel] = useState(false)
  const [type, setType] = useState('All')
  const [allReviewData, setAllReviewData] = useState<any>({
    series: [
      {
        name: 'reviews',
        type: 'area',
        data: [4, 3, 3, 1.5, 1.5, 4, 4, 3, 3, 5, 5, 3],
      },
    ],
    options: {
      chart: {
        height: 350,
        type: 'area',
        stacked: false,
        zoom: {
          type: 'x',
          enabled: false,
          autoScaleYaxis: true,
        },
        toolbar: {
          show: false,
        },
      },
      colors: ['#FCC419'],
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
      },
      title: {
        text: '',
        align: 'left',
      },
      fill: {
        type: 'gradient',
        gradient: {
          type: 'vertical',
          shadeIntensity: 1,
          inverseColors: false,
          opacityFrom: 0.5,
          opacityTo: 0,
          stops: [0, 90, 100],
        },
      },
      stroke: {
        width: 3,
        lineCap: 'round',
        curve: ['smooth', 'stepline', 'straight'],
      },
      labels: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ],
      xaxis: {
        type: 'category',
        tickAmount: 3,
      },
      yaxis: {
        labels: {
          formatter: function (val: any) {
            return val?.toFixed(0)
          },
        },
        min: 0,
      },
      tooltip: {
        x: {
          format: 'dd/MM/yy HH:mm',
        },
      },
    },
  })
  const [allActivityOverview, setAllActivityOverview] = useState<any>({
    series: [
      {
        name: 'TEAM A',
        type: 'column',
        data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30],
        color: '#50CD89',
      },
      {
        name: 'TEAM B',
        type: 'area',
        data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43],
        color: '#7950F2',
        zIndex: 1, // this option only affects line and area charts
      },
    ],
    options: {
      chart: {
        height: 350,
        type: 'area',
        stacked: false,
        zoom: {
          type: 'x',
          enabled: false,
          autoScaleYaxis: true,
        },
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      markers: {
        size: 0,
      },
      title: {
        text: '',
        align: 'left',
      },

      stroke: {
        width: [0, 2, 5],
        curve: 'smooth',
      },
      plotOptions: {
        bar: {
          columnWidth: '50%',
        },
      },

      fill: {
        opacity: [0.85, 0.25, 1],
        gradient: {
          inverseColors: false,
          shade: 'light',
          type: 'vertical',
          opacityFrom: 0.85,
          opacityTo: 0.55,
          stops: [0, 100, 100, 100],
        },
      },
      labels: [
        '01/01/2003',
        '02/01/2003',
        '03/01/2003',
        '04/01/2003',
        '05/01/2003',
        '06/01/2003',
        '07/01/2003',
        '08/01/2003',
        '09/01/2003',
        '10/01/2003',
        '11/01/2003',
      ],
      xaxis: {
        type: 'datetime',
      },
      yaxis: {
        labels: {
          formatter: function (val: any) {
            return val?.toFixed(0)
          },
        },
      },
      tooltip: {
        shared: true,
        intersect: false,
        y: {
          formatter: function (y: any) {
            if (typeof y !== 'undefined') {
              return y.toFixed(0) + ' points'
            }
            return y
          },
        },
      },
    },
  })
  const [deleteIds, setDeleteIds] = useState<string | null>(null)
  const [confirm, setConfirm] = useState<boolean>(false)

  const [page, setPage] = useState({
    page: 1,
    size: 10,
  })

  useEffect(() => {
    if (confirm == true) {
      setConfirm(false)
      setDeleteIds(null)
    }
  }, [confirm])

  const confirmation = useMemo(
    () => (
      <DeleteConfirmationPopup
        show={!!deleteIds}
        stopClose={false}
        handleClose={() => setDeleteIds(null)}
        Message={'Are you sure, you want to delete Automation?'}
        confirm={() => setConfirm(true)}
      />
    ),
    [deleteIds]
  )

  return (
    <>
      {confirmation}

      <div className='card p-0 bg-transparent Analytics_chart_page review_container'>
        <div className='row mx-n4'>
          <div className='col-lg-6 mt-2 px-4'>
            <div className='card p-8 py-5'>
              <div className='card-header border-0 p-0 align-items-center'>
                <div className='d-flex align-items-start gap-7'>
                  <img src='media/patterns/patten-2.svg' alt='patten' />
                  <div className='d-flex align-items-start flex-column  review_label'>
                    <h2 className='title'>Cellcast</h2>
                    <h2 className='rating-text'>4.9 Excellent rating</h2>
                    <div className='rating'>
                      <div className='rating-label checked'>
                        <KTSVG
                          path='media/icons/duotune/general/gen029.svg'
                          className='svg-icon svg-icon-1'
                        />
                      </div>
                      <div className='rating-label checked'>
                        <KTSVG
                          path='media/icons/duotune/general/gen029.svg'
                          className='svg-icon svg-icon-1'
                        />
                      </div>
                      <div className='rating-label checked'>
                        <KTSVG
                          path='media/icons/duotune/general/gen029.svg'
                          className='svg-icon svg-icon-1'
                        />
                      </div>
                      <div className='rating-label checked'>
                        <KTSVG
                          path='media/icons/duotune/general/gen029.svg'
                          className='svg-icon svg-icon-1'
                        />
                      </div>
                      <div className='rating-label checked'>
                        <KTSVG
                          path='media/icons/duotune/general/gen029.svg'
                          className='svg-icon svg-icon-1'
                        />
                      </div>
                    </div>
                    <h2 className='review'>based on 133 reviews</h2>
                  </div>
                </div>
              </div>
              <div className='card-body px-0 pt-5 review_label_body'>
                <h2 className='title'>Distribution of ratings</h2>
                <div className='rating-box'>
                  <div className='d-flex align-items-center rating-area'>
                    <h6 className='title'>5 star</h6>
                    <div
                      className='h-8px mx-3 w-100  rounded'
                      style={{
                        background: '#F2EEFF ',
                      }}
                    >
                      <div
                        className='rounded h-8px'
                        role='progressbar'
                        style={{width: '90%', background: '#4C946D'}}
                        aria-valuenow={50}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      ></div>
                    </div>
                    <h6 className='desc'>90 % (120)</h6>
                  </div>
                  <div className='d-flex align-items-center rating-area'>
                    <h6 className='title'>5 star</h6>
                    <div
                      className='h-8px mx-3 w-100  rounded'
                      style={{
                        background: '#E8FFF3 ',
                      }}
                    >
                      <div
                        className='rounded h-8px'
                        role='progressbar'
                        style={{width: '60%', background: '#50CD89'}}
                        aria-valuenow={50}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      ></div>
                    </div>
                    <h6 className='desc'>60 % (120)</h6>
                  </div>
                  <div className='d-flex align-items-center rating-area'>
                    <h6 className='title'>5 star</h6>
                    <div
                      className='h-8px mx-3 w-100  rounded'
                      style={{
                        background: '#F3F0FB ',
                      }}
                    >
                      <div
                        className='rounded h-8px'
                        role='progressbar'
                        style={{width: '20%', background: '#65B241'}}
                        aria-valuenow={50}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      ></div>
                    </div>
                    <h6 className='desc'>20 % (120)</h6>
                  </div>
                  <div className='d-flex align-items-center rating-area'>
                    <h6 className='title'>5 star</h6>
                    <div
                      className='h-8px mx-3 w-100  rounded'
                      style={{
                        background: '#FFF3DD ',
                      }}
                    >
                      <div
                        className='rounded h-8px'
                        role='progressbar'
                        style={{width: '40%', background: '#F69400'}}
                        aria-valuenow={50}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      ></div>
                    </div>
                    <h6 className='desc'>40 % (120)</h6>
                  </div>
                  <div className='d-flex align-items-center rating-area'>
                    <h6 className='title'>5 star</h6>
                    <div
                      className='h-8px mx-3 w-100  rounded'
                      style={{
                        background: '#FFF5F8 ',
                      }}
                    >
                      <div
                        className='rounded h-8px'
                        role='progressbar'
                        style={{width: '70%', background: '#F1416C'}}
                        aria-valuenow={50}
                        aria-valuemin={0}
                        aria-valuemax={100}
                      ></div>
                    </div>
                    <h6 className='desc'>70 % (120)</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-lg-6 mt-2 px-4'>
            <div className='card p-8 pt-5 pb-0'>
              <div className='card-header border-0 p-0 align-items-center'>
                <h3 className='card-title align-items-start  flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>Reviews</span>
                  <span className='text-muted mt-1 fw-bold fs-7'>All your reviews</span>
                </h3>
                <div
                  className='card-toolbar align-items-start flex-column'
                  style={{
                    color: '#FCC419',
                    fontSize: '24px',
                    fontWeight: 600,
                  }}
                >
                  1,221
                </div>
              </div>
              <div className='card-body px-0 pt-5 pb-0'>
                <div className='analytics_charts'>
                  {true ? (
                    <div className='chart_body'>
                      <ReactApexChart
                        options={allReviewData?.options}
                        series={allReviewData?.series}
                        height={310}
                      />
                    </div>
                  ) : (
                    <NodataYet />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='card p-0 bg-transparent Analytics_chart_page'>
        <div className='row mt-8'>
          <div className='col-12'>
            <div className='card p-8 py-5 pt-8'>
              <div className='card-header border-0 p-0 align-items-start'>
                <h3 className='card-title align-items-start  flex-column'>
                  <span className='card-label fw-bolder fs-2 mb-1'>Activity overview</span>
                  <span className='text-muted mt-1 fw-bold fs-7'>See how you're progressing</span>
                </h3>
                <div className='card-toolbar align-items-start flex-column'>
                  <ul className='nav nav-tabs activity_tabs' id='myTab' role='tablist'>
                    <li className='nav-item' role='presentation'>
                      <button
                        className='nav-link active'
                        id='all-flow-tab'
                        data-bs-toggle='tab'
                        data-bs-target='#all-flow'
                        type='button'
                        role='tab'
                        aria-controls='all-flow'
                        aria-selected='true'
                        onClick={() => setType('All')}
                      >
                        <span className='symbol-label'>
                          <KTSVG
                            path='/media/icons/duotune/navigationicon/medal_star.svg'
                            className='svg-icon-2x'
                          />
                        </span>
                        All
                      </button>
                    </li>
                    <li className='nav-item' role='presentation'>
                      <button
                        className='nav-link'
                        id='Lead-generation-tab'
                        data-bs-toggle='tab'
                        data-bs-target='#Lead-generation'
                        type='button'
                        role='tab'
                        aria-controls='Lead-generation'
                        aria-selected='false'
                        onClick={() => setType('Reviews')}
                      >
                        <span className='symbol-label'>
                          <KTSVG
                            path='/media/icons/duotune/navigationicon/star.svg'
                            className='svg-icon-2x'
                          />
                        </span>
                        Reviews
                      </button>
                    </li>
                    <li className='nav-item' role='presentation'>
                      <button
                        className='nav-link '
                        id='Total-tab'
                        data-bs-toggle='tab'
                        data-bs-target='#Total'
                        type='button'
                        role='tab'
                        aria-controls='Total'
                        aria-selected='false'
                        onClick={() => setType('Messages')}
                      >
                        <span className='symbol-label'>
                          <KTSVG
                            path='/media/icons/duotune/navigationicon/messages.svg'
                            className='svg-icon-2x'
                          />
                        </span>
                        Messages
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className='card-body px-0 pt-5 tab-content'>
                <div
                  className='analytics_charts tab-pane fade show active'
                  id='all-flow'
                  role='tabpanel'
                  aria-labelledby='all-flow-tab'
                >
                  <div className='chart_head'>
                    <div className='chart_item'>
                      <strong>6,684</strong>
                      <span>New reviews</span>
                    </div>
                    <div className='chart_item'>
                      <strong>14,706</strong>
                      <span>Messages sent</span>
                    </div>
                    <div className='chart_item'>
                      <strong
                        className='d-flex align-items-center'
                        style={{
                          gap: '7px',
                        }}
                      >
                        <div>46%</div>
                        <div
                          className=' badge-light-success'
                          style={{
                            fontWeight: '600',
                            fontSize: '12px',
                            height: 'fit-content',
                            padding: '7px',
                            borderRadius: '4px',
                          }}
                        >
                          <span className='arrow'>
                            <KTSVG path='/media/misc/arrow-up.svg' className='' />
                          </span>
                          4.5%
                        </div>
                      </strong>
                      <span>Review / message</span>
                    </div>
                  </div>
                  {/* {leadData?.length > 0 ? ( */}
                  <div className='chart_body'>
                    <ReactApexChart
                      options={allActivityOverview?.options}
                      series={allActivityOverview?.series}
                      height={350}
                    />
                    {/* <img src={toAbsoluteUrl('/media/misc/lead-generation-chart.png')} alt='Image' /> */}
                  </div>
                  {/* ) : (
                    <NodataYet />
                  )} */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='card my-10'>
        <div className='card-header border-0 pt-12'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bolder fs-2 mb-1'>Review flows</span>
            <span className='text-muted mt-1 fw-bold fs-7'>Ordered by most recent</span>
          </h3>
          <div className='card-toolbar m-0'>
            <div className='d-flex gap-3 align-items-center'>
              <button
                className='btn btn-primary'
                onClick={() => {
                  setQuickResponseModel(true)
                }}
              >
                Create new
              </button>
            </div>
          </div>
        </div>
        <div className='card-body pt-2'>
          <div className='tab-content'>
            <div className='table-responsive'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bold text-muted text-uppercase'>
                    <th>TITLE</th>
                    <th>TRIGGER</th>
                    <th>STARTED</th>
                    <th>IN PROGRESS</th>
                    <th>COMPLETED</th>
                    <th>LAST UPDATED</th>
                    <th>STATUS</th>
                    <th className='w-100px'>Action</th>
                  </tr>
                </thead>
                <tbody className='text-gray-600'>
                  <tr>
                    <td className='fw-bold cursor-pointer'>Service Review</td>
                    <td>Segment</td>
                    <td>41</td>
                    <td>2</td>
                    <td>10</td>
                    <td>May 24 at 1:44 PM</td>
                    <td>
                      <span className='badge badge-light-info'>Active</span>
                    </td>
                    <td>
                      <div
                        className='row'
                        style={{
                          minWidth: '140px',
                        }}
                      >
                        <a
                          className=' col-4 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          onClick={() => setQuickResponseModel(true)}
                        >
                          <span className='svg-icon svg-icon-3'>
                            <i className='bi bi-pencil-fill'></i>
                          </span>
                        </a>
                        <a className=' col-4 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'>
                          <span className='svg-icon svg-icon-3'>
                            <FileCopyTwoTone />
                          </span>
                        </a>
                        <a className=' col-4 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'>
                          <span className='svg-icon svg-icon-3'>
                            <i className='bi bi-trash3-fill'></i>
                          </span>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className='fw-bold cursor-pointer'>Product review</td>
                    <td>Segment</td>
                    <td>41</td>
                    <td>2</td>
                    <td>10</td>
                    <td>May 24 at 1:44 PM</td>
                    <td>
                      <span className='badge badge-light-info'>Active</span>
                    </td>
                    <td>
                      <div
                        className='row'
                        style={{
                          minWidth: '140px',
                        }}
                      >
                        <a
                          className=' col-4 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          onClick={() => setQuickResponseModel(true)}
                        >
                          <span className='svg-icon svg-icon-3'>
                            <i className='bi bi-pencil-fill'></i>
                          </span>
                        </a>
                        <a className=' col-4 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'>
                          <span className='svg-icon svg-icon-3'>
                            <FileCopyTwoTone />
                          </span>
                        </a>
                        <a className=' col-4 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'>
                          <span className='svg-icon svg-icon-3'>
                            <i className='bi bi-trash3-fill'></i>
                          </span>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className='fw-bold cursor-pointer'>Review 2</td>
                    <td>Segment</td>
                    <td>41</td>
                    <td>2</td>
                    <td>10</td>
                    <td>May 24 at 1:44 PM</td>
                    <td>
                      <span className='badge badge-light-danger'>Inactive</span>
                    </td>
                    <td>
                      <div
                        className='row'
                        style={{
                          minWidth: '140px',
                        }}
                      >
                        <a
                          className=' col-4 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                          onClick={() => setQuickResponseModel(true)}
                        >
                          <span className='svg-icon svg-icon-3'>
                            <i className='bi bi-pencil-fill'></i>
                          </span>
                        </a>
                        <a className=' col-4 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'>
                          <span className='svg-icon svg-icon-3'>
                            <FileCopyTwoTone />
                          </span>
                        </a>
                        <a className=' col-4 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'>
                          <span className='svg-icon svg-icon-3'>
                            <i className='bi bi-trash3-fill'></i>
                          </span>
                        </a>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div className='abcd '>
                <select onChange={(e: any) => setPage({...page, size: e.target.value, page: 1})}>
                  <option value={10}>10</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                  {/* <option value={tagslist?.total}>ALL</option> */}
                </select>
                <ReactPaginate
                  previousLabel='<'
                  nextLabel='>'
                  pageCount={1}
                  onPageChange={(e) => setPage({...page, page: e.selected + 1})}
                  containerClassName={'pagiantion'}
                  previousLinkClassName={'pagination__link'}
                  nextLinkClassName={'pagination__link'}
                  disabledClassName={'pagination__link--disabled'}
                  activeClassName={'pagination__link--active'}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Reviews
